import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;

import styled from '@xstyled/styled-components';
import { TextLinkButton } from '@lib/common';
import { PlusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { Divider, message, Popover } from 'antd';
import { styleVariables } from '@lib/common';
import { QuestionType } from '@module/form';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledPopover = styled(Popover)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  border-radius: 10px;\n  width: 48px;\n  height: 48px;\n  background: ", ";\n  border-radius: 8px;\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.15);\n  right: 8%;\n  top: 40%;\n  border-radius: 50%;\n"])), function (props) {
  return props.$active ? styleVariables.colors.colorPrimaryBase : styleVariables.colors.gray7;
});
var StyledPlusButton = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 48px;\n  height: 48px;\n  background: ", ";\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.15);\n  border-radius: 50%;\n  cursor: pointer;\n"])), function (props) {
  return props.$active ? styleVariables.colors.colorPrimaryBase : styleVariables.colors.gray7;
});
var AccessibilityBarWrapper = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  z-index: 1;\n\n  &:hover {\n    opacity: 0.8;\n    transition-delay: 0.05s;\n  }\n"])));
var StyledGroupQuestionTitle = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  font-size: 16px;\n  margin-bottom: 12px;\n  margin-top: 12px;\n"])));
var PlusIcon = styled(PlusOutlined)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  font-size: 30px;\n\n  svg {\n    color: ", ";\n  }\n"])), styleVariables.colors.gray1);
var QuestionListContainer = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n"])));
var StyledTitle = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  font-size: 16px;\n  margin-bottom: 12px;\n"])));
var StyledTextLinkButton = styled(TextLinkButton)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-weight: 500;\n  line-height: 24px;\n"])), styleVariables.colors.colorPrimaryBase);
var StyledAddSessionButton = styled(TextLinkButton)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  font-weight: 500;\n"])));
export var AccessibilityBar = function AccessibilityBar(_ref) {
  var onCreateSection = _ref.onCreateSection,
      onCreateQuestion = _ref.onCreateQuestion,
      visible = _ref.visible,
      onTriggerVisibleChange = _ref.onTriggerVisibleChange,
      hasUnsavedQuestionOrSectionChanges = _ref.hasUnsavedQuestionOrSectionChanges,
      labelTranslation = _ref.labelTranslation,
      possibleQuestionCreationTypes = _ref.possibleQuestionCreationTypes,
      onCreateHeading = _ref.onCreateHeading,
      _ref$isHideCreateQues = _ref.isHideCreateQuestionOptions,
      isHideCreateQuestionOptions = _ref$isHideCreateQues === void 0 ? false : _ref$isHideCreateQues;

  var renderAllQuestionTypeOptions = function renderAllQuestionTypeOptions() {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(StyledTitle, {
        children: labelTranslation.addQuestion
      }), /*#__PURE__*/_jsx(StyledTextLinkButton, {
        onClick: function onClick() {
          return onCreateQuestion(QuestionType.SingleChoice);
        },
        icon: /*#__PURE__*/_jsx(PlusCircleOutlined, {}),
        children: labelTranslation.singleChoiceQuestion
      }), /*#__PURE__*/_jsx(StyledTextLinkButton, {
        onClick: function onClick() {
          return onCreateQuestion(QuestionType.MultipleChoice);
        },
        icon: /*#__PURE__*/_jsx(PlusCircleOutlined, {}),
        children: labelTranslation.multipleChoiceQuestion
      }), /*#__PURE__*/_jsx(StyledTextLinkButton, {
        onClick: function onClick() {
          return onCreateQuestion(QuestionType.Essay);
        },
        icon: /*#__PURE__*/_jsx(PlusCircleOutlined, {}),
        children: labelTranslation.essay
      }), /*#__PURE__*/_jsx(StyledGroupQuestionTitle, {
        children: labelTranslation.addGroupQuestions
      }), /*#__PURE__*/_jsx(StyledTextLinkButton, {
        onClick: function onClick() {
          return onCreateQuestion(QuestionType.FillInBlank);
        },
        icon: /*#__PURE__*/_jsx(PlusCircleOutlined, {}),
        children: labelTranslation.fillInBlankQuestion
      }), /*#__PURE__*/_jsx(StyledTextLinkButton, {
        onClick: function onClick() {
          return onCreateQuestion(QuestionType.Matching);
        },
        icon: /*#__PURE__*/_jsx(PlusCircleOutlined, {}),
        children: labelTranslation.matchingQuestion
      })]
    });
  };

  var renderQuestionTypeOptions = function renderQuestionTypeOptions() {
    if (!possibleQuestionCreationTypes) {
      return renderAllQuestionTypeOptions();
    }

    var hasBasicQuestionType = possibleQuestionCreationTypes.some(function (type) {
      return QuestionType.isBasicQuestionType(type);
    });
    var hasGroupQuestionType = possibleQuestionCreationTypes.some(function (type) {
      return QuestionType.isGroupQuestionType(type);
    });
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [hasBasicQuestionType && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(StyledTitle, {
          children: labelTranslation.addQuestion
        }), possibleQuestionCreationTypes.filter(function (type) {
          return QuestionType.basicQuestionTypes.includes(type);
        }).map(function (type) {
          switch (type) {
            case QuestionType.SingleChoice:
              {
                return /*#__PURE__*/_jsx(StyledTextLinkButton, {
                  onClick: function onClick() {
                    return onCreateQuestion(QuestionType.SingleChoice);
                  },
                  icon: /*#__PURE__*/_jsx(PlusCircleOutlined, {}),
                  children: labelTranslation.singleChoiceQuestion
                });
              }

            case QuestionType.MultipleChoice:
              {
                return /*#__PURE__*/_jsx(StyledTextLinkButton, {
                  onClick: function onClick() {
                    return onCreateQuestion(QuestionType.MultipleChoice);
                  },
                  icon: /*#__PURE__*/_jsx(PlusCircleOutlined, {}),
                  children: labelTranslation.multipleChoiceQuestion
                });
              }

            case QuestionType.Essay:
              {
                return /*#__PURE__*/_jsx(StyledTextLinkButton, {
                  onClick: function onClick() {
                    return onCreateQuestion(QuestionType.Essay);
                  },
                  icon: /*#__PURE__*/_jsx(PlusCircleOutlined, {}),
                  children: labelTranslation.essay
                });
              }
          }
        })]
      }), hasGroupQuestionType && /*#__PURE__*/_jsxs(_Fragment, {
        children: [possibleQuestionCreationTypes.some(function (type) {
          return QuestionType.isGroupQuestionType(type);
        }) && /*#__PURE__*/_jsx(StyledGroupQuestionTitle, {
          children: labelTranslation.addGroupQuestions
        }), possibleQuestionCreationTypes.filter(function (type) {
          return QuestionType.groupQuestionTypes.includes(type);
        }).map(function (type) {
          switch (type) {
            case QuestionType.FillInBlank:
              {
                return /*#__PURE__*/_jsx(StyledTextLinkButton, {
                  onClick: function onClick() {
                    return onCreateQuestion(QuestionType.FillInBlank);
                  },
                  icon: /*#__PURE__*/_jsx(PlusCircleOutlined, {}),
                  children: labelTranslation.fillInBlankQuestion
                });
              }

            case QuestionType.Matching:
              {
                return /*#__PURE__*/_jsx(StyledTextLinkButton, {
                  onClick: function onClick() {
                    return onCreateQuestion(QuestionType.Matching);
                  },
                  icon: /*#__PURE__*/_jsx(PlusCircleOutlined, {}),
                  children: labelTranslation.matchingQuestion
                });
              }
          }
        })]
      }), /*#__PURE__*/_jsx(Divider, {})]
    });
  };

  var content = /*#__PURE__*/_jsxs(QuestionListContainer, {
    children: [!isHideCreateQuestionOptions && renderQuestionTypeOptions(), !isHideCreateQuestionOptions && /*#__PURE__*/_jsx(StyledAddSessionButton, {
      onClick: onCreateHeading,
      icon: /*#__PURE__*/_jsx(PlusOutlined, {}),
      children: labelTranslation.addHeading
    }), /*#__PURE__*/_jsx(StyledAddSessionButton, {
      onClick: onCreateSection,
      icon: /*#__PURE__*/_jsx(PlusOutlined, {}),
      children: labelTranslation.addSection
    })]
  });

  var handleBlockedCreateClick = function handleBlockedCreateClick() {
    message.warning(labelTranslation.questionChangingWarning);
  };

  return /*#__PURE__*/_jsx(AccessibilityBarWrapper, {
    children: !hasUnsavedQuestionOrSectionChanges ? /*#__PURE__*/_jsx(StyledPopover, {
      open: visible,
      placement: "bottom",
      content: content,
      onOpenChange: onTriggerVisibleChange,
      trigger: "click",
      id: "add-plus-button",
      $active: true,
      children: /*#__PURE__*/_jsx(PlusIcon, {})
    }) :
    /*#__PURE__*/
    // Click (not hover) so the warning does not auto-open when the mouse is
    // still over the + button right after creating a question.
    _jsx(StyledPlusButton, {
      $active: false,
      onClick: handleBlockedCreateClick,
      children: /*#__PURE__*/_jsx(PlusIcon, {})
    })
  });
};